export enum ActivityToMapType {
  Rest = 0,
  Availability = 1,
  AvailabilityInCrew = 2,
  Work = 3,
}
